<template>
	<div class="container">
		<expense-log-form></expense-log-form>
	</div>
</template>

<script>
import ExpenseLogForm from "../components/super_components/ExpenseLogForm"

export default {

	name: 'LogExpense',
	components: {
		ExpenseLogForm
	}

}
</script>